export enum FamilyMemberType {
  SELF = 'SELF',
  SPOUSE = 'SPOUSE',
  CHILDREN = 'CHILDREN',
  PARENT = 'PARENT',
  SIBLING = 'SIBLING',
}

export const getFamilyMemberTypeLabel = (
  type: FamilyMemberType | string
): string => {
  switch (type) {
    case FamilyMemberType.SELF:
      return $localize`Titulaire`;
    case FamilyMemberType.SPOUSE:
      return $localize`Conjoint(e)`;
    case FamilyMemberType.CHILDREN:
      return $localize`Enfant`;
    case FamilyMemberType.PARENT:
      return $localize`Parent`;
    case FamilyMemberType.SIBLING:
      return $localize`Frère/Sœur`;
    default:
      return type;
  }
};

export const getFamilyMemberTypeRelativeTo = (
  type: FamilyMemberType,
  relativeTo: FamilyMemberType
): FamilyMemberType => {
  switch (relativeTo) {
    case FamilyMemberType.SELF:
      return type;
    case FamilyMemberType.SPOUSE:
      if (type === FamilyMemberType.SELF) return FamilyMemberType.SPOUSE;
      return type;
    case FamilyMemberType.CHILDREN:
      if (type === FamilyMemberType.CHILDREN) return FamilyMemberType.SIBLING;
      return FamilyMemberType.PARENT;
    default:
      return type;
  }
};

export const getFamilyMemberTypeIcon = (type: FamilyMemberType): string => {
  switch (type) {
    case FamilyMemberType.SELF:
      return 'assets/images/star.svg';
    case FamilyMemberType.SPOUSE:
      return 'assets/images/heart.svg';
    case FamilyMemberType.CHILDREN:
      return 'assets/images/family.svg';
    case FamilyMemberType.PARENT:
      return 'assets/images/family-parent.svg';
    case FamilyMemberType.SIBLING:
      return 'assets/images/single-man.svg';
    default:
      return '';
  }
};

export type FilterableFamilyMemberType = Omit<
  FamilyMemberType,
  FamilyMemberType.PARENT | FamilyMemberType.SIBLING
>;

export const COMPANY_ICON = 'assets/images/company_icon.svg';
